/* eslint-disable sonarjs/cognitive-complexity */
import Picture from '@base/components/picture'
import OpenApp, { Browser, UNIVERSAL_DOMAIN } from '@base/utils/open-app'
import { getUrl } from '@fe/utils'
import { Fragment, useEffect, useMemo, useState } from 'react'
import { sensorsTrack } from '../../utils/sensors'
import s from './index.module.scss'
import Mask from './Mask'
import RegisterForm from './RegisterForm'
import axios from '../../services/axios'
import storage from '../../utils/storage'
import { GUIDE_IMAGE_BG_KEY } from '../../config/constants'
import { PACKAGE } from '@base/constants'
import { useMemoizedFn } from 'ahooks'
import { getOpenAppSensorsPublicParams } from '@r/page/src/utils'
const appName = getUrl(location.href, 'appName') ? decodeURIComponent(getUrl(location.href, 'appName')) : '中免日上APP'
const appVersion = getUrl(location.href, 'appVersion') ? decodeURIComponent(getUrl(location.href, 'appVersion')) : '1.4.2'
const updateTime = getUrl(location.href, 'updateTime') ? decodeURIComponent(getUrl(location.href, 'updateTime')) : '2023.08.29'
// const subTitle = getUrl(location.href, 'subTitle') ? decodeURIComponent(getUrl(location.href, 'subTitle')) : ''

const comply = getUrl(location.href, 'comply') == '1'

const agreementLink = 'https://lefox-app-cdn.cdfsunrise.com/html/statement/agreement.html'
const privacyLink = 'https://lefox-app-cdn.cdfsunrise.com/html/statement/privacy.html'

let openApp: OpenApp
// const MINI_WXA = `https://api.cdfsunrise.com/restapi/wechat/link?linkPath=home&linkType=2&source_from=${getUrl(location.href, 'source_from') || 'downloadpage'}`
const DefaultGuideImage = 'https://lefox-app-cdn.cdfsunrise.com/resources/front/images/2025-07-25/ec36c106-d963-48dc-998c-1f62de2756a6__1753425276059__w1125__h1500.png'

// 页面参数类型 不要删 如果新增了 需要补充下
interface QueryParams extends Record<string, string> {
  // 跳转schema
  appSchema?: string
  // 应用名称
  appName?: string
  // 应用版本
  appVersion?: string
  // 更新时间
  updateTime?: string
  // 消息类型
  messagetype?: string
  // 消息渠道
  msg_channel?: string
  // 来源
  source_from?: string
  // 是否同意隐私政策
  comply?: string
  // 页面
  page?: string
}

function Home() {
  const [pop, setPop] = useState(false)
  const [mask, setMask] = useState(false)
  // 应用推广集合H5，值=downloadpage
  // 线下地推小程序扫码，值=offlinetomp

  const [guideImg, setGuideImg] = useState<string>(() => {
    return storage.get(GUIDE_IMAGE_BG_KEY) || DefaultGuideImage
  })

  const loadUI = async () => {
    let bg = ''
    try {
      const res = (await axios({
        method: 'GET',
        url: 'https://data-library-cdn.cdfsunrise.com/content/688347f96d811b0001ab9f74.json',
      })) as any
      const { img } = res?.data || {}
      bg = img || DefaultGuideImage
    } catch (error) {
      console.log(error)
      bg = DefaultGuideImage
    }
    storage.set(GUIDE_IMAGE_BG_KEY, bg)
    setGuideImg(bg)
  }

  /**
   * @description 获取APP下载链接
   */

  const getAppDownloadUrl = async () => {
    try {
      const res = (await axios({
        url: '/restapi/wireless/channel/downloadLink',
        method: 'POST',
        data: {
          packageId: PACKAGE,
          clientType: 'Android',
          channelId: 'zmrshyrw',
        },
      })) as any
      return res?.data?.downloadUrl
    } catch (error) {
      return ''
    }
  }

  // 点击下载app
  const handleDownload = () => {
    sensorsTrack('GotoAppClick', 'H5回流按钮点击', {
      gotoapp_type: Browser.isAndroid ? 'Android' : Browser.isIos ? 'iOS' : 'H5',
      ...getOpenAppSensorsPublicParams(),
    })

    if (location.href.includes(UNIVERSAL_DOMAIN)) {
      // 这里如果是微信环境 在页面useMount的时候 没有换起来 就已经有问题了
      // 所以兜底直接引导用户用浏览器打开
      if (Browser.isWechat) {
        setMask(true)
      }

      openApp.open()
    } else {
      // donwload 所在页面
      if (Browser.isAndroid) {
        if (Browser.isWechat || Browser.isFeishu) {
          setMask(true)
        } else {
          // 尝试去打开
          openApp.open()
        }
      }
      // iOS + 鸿蒙
      else {
        // 永远尝试去打开
        openApp.open()
      }
    }
  }

  // 打开小程序
  // const handlViewMp = () => {
  //   sensorsTrack('GotoAppClick', 'H5回流按钮点击', {
  //     gotoapp_type: '小程序',
  //   })

  //   // TODO
  //   // 需要将该码，设置为永久不过期
  //   location.href = MINI_WXA
  //   // location.replace(MINI_WXA)
  // }

  const init = useMemoizedFn(async () => {
    const url = await getAppDownloadUrl()
    console.log('url --->', url)

    openApp = new OpenApp({
      DEF_APK_URL: url,
    })

    if (location.href.includes(UNIVERSAL_DOMAIN)) {
      // 必然没有安装app
      // 直接调起app store ？
      // 必然是ios
      // window.location.href = APP_STORE_ADDRESS // 难以理解我们的产品
      // 如果是在微信里面且是安卓手机
      if (Browser.isWechat && Browser.isAndroid) {
        setMask(true)
        return
      }
      if (Browser.isWechat && Browser.isIos) {
        openApp.open()
        return
      }
      openApp.open()
    }
  })

  // 页面打开之际
  useEffect(() => {
    init()
  }, [])

  useEffect(() => {
    // 加载配置
    loadUI()
  }, [])

  return useMemo(() => {
    return (
      <Fragment>
        {mask && <Mask visible={mask} setVisible={setMask} />}
        {pop && <RegisterForm setVisible={setPop} openApp={openApp} />}

        <div className={s.mainNew}>
          {comply && (
            <div className={s.appInfoBox}>
              <div>开发者：中免日上互联科技有限公司｜{appName}</div>
              <div className={s.mt4}>
                应用版本：{appVersion} | 更新时间：{updateTime} | <a href={agreementLink}>应用权限</a> | <a href={privacyLink}>隐私政策</a>
              </div>
            </div>
          )}
          <div className={s.guideImageWrapper}>
            <div className={s.guideImg}>
              <img src={guideImg} />
            </div>
          </div>
          <div className={s.footer}>
            <div className={s.footerLogo}>
              <Picture src={'https://lefox-app-cdn.cdfsunrise.com/resources/front/images/2025-07-25/c6987f98-1a7f-41df-8dfa-0acd62226703__1753427046233__w156__h168.png'} domain="download" />
              <div className={s.info}>
                <p className={s.infoName}>中免日上</p>
                <p className={s.infoSubTitle}>全球大牌美妆</p>
              </div>
            </div>
            <div className={s.footerTag}>央企严选·100%正品保障</div>
            <p className={s.footerDownloadBtn} onClick={handleDownload}>
              下载中免日上APP
            </p>
          </div>
        </div>
      </Fragment>
    )
  }, [mask, pop, guideImg])
}

export default Home
